import { createBrowserHistory } from 'history';
import {
  AuthService,
  UserService,
} from '@pingum/api-services';
import Auth0Lock from '../../services/AuthService/Auth0LockService';
import * as types from './types';

export const loginRequest = ({ history = createBrowserHistory() } = {}) => {
  if (AuthService.isLoggedIn()) {
    history.push({ pathname: '/organizations' });
    history.go();
    return { type: types.LOGIN_SUCCESS };
  }
  Auth0Lock.login();
  return { type: types.LOGIN_REQUEST };
};

export const signupRequest = () => {
  Auth0Lock.signup();
  return { type: types.LOGIN_REQUEST };
};

export const loginSuccess = () => ({ type: types.LOGIN_SUCCESS });

export const loginError = ({
  error = {},
  history = createBrowserHistory(),
} = {}) => {
  if (error.errorDescription === 'Please verify your email before logging in.') {
    history.push({ pathname: '/confirm-email' });
    history.go();
  }

  return {
    type: types.LOGIN_ERROR,
    error,
  };
};

export const logoutSuccess = () => {
  Auth0Lock.logout();
  UserService.clearLocalStorage();
  return { type: types.LOGOUT_SUCCESS };
};
